/* eslint-disable no-underscore-dangle */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Select, Tooltip } from '@/components';
import RTCModel from '@/models/rtc';
import MeetingModel from '@/models/meeting';
import Style from './index.less';

interface SettingPanelProps {
  RTCInstance?: RTCModel;
  meeting?: MeetingModel;
}

const SettingPanel: React.FC<SettingPanelProps> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { RTCInstance } = props;
    const { formatMessage } = useIntl();

    React.useEffect(() => {
      RTCInstance?.getDeviceOptions(false);
    }, []);
    return (
      <div
        className={classnames(Style['setting-panel'])}
        onClick={(e) => {
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <div className={Style.device}>
          <h3 className={Style.name}>{formatMessage({ id: 'SPEAKER' })}</h3>
          <div className={Style.option}>
            <div className={Style.value}>
              <Select
                popupClassName={Style['setting-select-popup']}
                onChange={RTCInstance?.setAudioOutValue.bind(RTCInstance) as any}
                className={Style['setting-select']}
                value={RTCInstance?.audioOutValue}
                options={RTCInstance?.deviceOptions.audioOut}
              />
            </div>
          </div>
        </div>
        <div className={Style.device}>
          <h3 className={Style.name}>{formatMessage({ id: 'MICROPHONE' })}</h3>
          <div className={Style.option}>
            <div className={Style.value}>
              <Tooltip
                title={!RTCInstance?.isOpenAudio ? formatMessage({ id: 'SWITCH_MIC_TIPS' }) : ''}
              >
                <Select
                  popupClassName={Style['setting-select-popup']}
                  onChange={RTCInstance?.setAudioInValue.bind(RTCInstance) as any}
                  disabled={!RTCInstance?.isOpenAudio}
                  className={Style['setting-select']}
                  value={RTCInstance?.audioInValue}
                  options={RTCInstance?.deviceOptions.audioIn}
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <div className={Style.device}>
          <h3 className={Style.name}>{formatMessage({ id: 'CAMERA' })}</h3>
          <div className={Style.option}>
            <div className={Style.value}>
              <Select
                popupClassName={Style['setting-select-popup']}
                onChange={RTCInstance?.setVideoValue.bind(RTCInstance)}
                className={Style['setting-select']}
                value={RTCInstance?.videoValue}
                options={RTCInstance?.deviceOptions.videoList}
              />
            </div>
          </div>
        </div>
        <span className={Style.triangle} />
      </div>
    );
  })
);
export default SettingPanel;
